// extracted by mini-css-extract-plugin
module.exports = {"container":"search_container__1uUBg","search":"search_search__1JxJG"};